export const RECEIVED_ALL_TASKS = 'lead/RECEIVED_ALL_TASKS';
export const RECEIVED_ERROR = 'lead/RECEIVED_ERROR';

export const UPDATE_TASK_STATUS_LOADING = 'task/UPDATE_TASK_STATUS_LOADING';
export const UPDATE_TASK_STATUS_SUCCESS = 'task/UPDATE_TASK_STATUS_SUCCESS';
export const UPDATE_TASK_STATUS_ERROR   = 'task/UPDATE_TASK_STATUS_ERROR';

export const REQUEST_GET_PAGED_TASKS = 'task/REQUEST_GET_PAGED_TASKS';
export const RECEIVED_PAGED_TASKS    = 'task/RECEIVED_PAGED_TASKS';

export const REQUEST_GET_TASK_STATUSBASED = 'task/REQUEST_GET_TASK_STATUSBASED';
export const RECEIVED_TASK_STATUSBASED    = 'task/RECEIVED_TASK_STATUSBASED';
export const REQUEST_GET_SUBTASKS         = 'task/REQUEST_GET_SUBTASKS';
export const RECEIVED_SUBTASKS            = 'task/RECEIVED_SUBTASKS';
export const UPDATE_TASK_STATUS_CONFLICT  = 'task/UPDATE_TASK_STATUS_CONFLICT';
